import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';

import $ from 'jquery';

function NewPassword() {

    let { host_id } = useParams();

    useEffect(() => {
        console.log("AAA",host_id);
        if(host_id!=undefined){
            $(".show-tbaCreateNewPasswordModal").click();
        }
    }, [])

    const history = useHistory();

    const [newPass, setNewPass] = useState({
        password: '',
        cpassword: '',
        host_id: host_id
    });

    const [errors, setErrors] = useState({});
    const [disable, setDisable] = useState(false);

    const handleInput = (e) => {

        const newSetPass = { ...newPass };

        var check = onlySpaces(e.target.value);
        if(check == false){
            newSetPass[e.target.name] = e.target.value;
            setNewPass(newSetPass);
        }else{
            newSetPass[e.target.name] = "";
            setNewPass(newSetPass);
        }

    }

    function onlySpaces(str) {
        return str.trim().length === 0;
      }

    const handleNewPassword = (e) => {
        e.preventDefault();
        if (validate()) {
            setDisable(true);
            const { host_id, password } = newPass;

            const myurl = "https://events.teambuildingawards.com:3000/api/web/set-new-password";
            var bodyFormData = new URLSearchParams();
            bodyFormData.append('host_id', host_id);
            bodyFormData.append('password', password);
            axios({
                method: "post",
                url: myurl,
                data: bodyFormData,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            }).then((response) => {
                if (response.data.success == true) {
                    
                    $(".tba-modal-close-btn").click();

                    setNewPass({
                        host_id: '',
                        password: '',
                        cpassword: '',
                    });

                    history.push(`/`);
                }

            }).catch((error) => {
                console.log("Errors", error);
            })


        }
    }

    const validate = () => {
        let input = newPass;

        let errors = {};
        let isValid = true;

        if (!input['password']) {
            isValid = false;
            errors['password_err'] = 'Please enter password';
          }

          if (!input['cpassword']) {
            isValid = false;
            errors['cpassword_err'] = 'Please enter confirm password';
          }

          if (input['password'] != input['cpassword']) {
            isValid = false;
            errors['cpassword_err'] = 'confirm password not match in password';
          }

        setErrors(errors);
        return isValid;
    }

    return (
        <>

<span  class="show-tbaCreateNewPasswordModal" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#tbaCreateNewPasswordModal"></span>

    <div className="modal fade" id="tbaCreateNewPasswordModal" tabindex="-1" aria-labelledby="tbaCreateNewPasswordLabel"
        aria-hidden="true" style={{pointerEvents: 'none'}}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                {/* <div className="modal-header">
                    <span data-bs-dismiss="modal" aria-label="Close" className="tba-modal-close-btn">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M25.4279 6.57187C22.9096 4.05353 19.5612 2.66666 15.9998 2.66666C12.4384 2.66666 9.0901 4.05353 6.57176 6.57192C4.05343 9.09025 2.6665 12.4385 2.6665 16C2.6665 19.5615 4.05338 22.9098 6.57171 25.4282C9.09005 27.9464 12.4383 29.3333 15.9998 29.3333C19.5612 29.3333 22.9096 27.9464 25.4279 25.4281C27.9462 22.9097 29.3332 19.5614 29.3332 16C29.3332 12.4385 27.9462 9.09025 25.4279 6.57187ZM24.3231 24.3233C22.0998 26.5464 19.1439 27.7708 15.9998 27.7708C12.8557 27.7708 9.89973 26.5464 7.67656 24.3233C5.45333 22.1 4.229 19.1442 4.229 16C4.229 12.8559 5.45343 9.89999 7.67661 7.67676C9.89984 5.45353 12.8557 4.22916 15.9998 4.22916C19.144 4.22916 22.0998 5.45353 24.3231 7.67671C28.9124 12.2662 28.9124 19.7338 24.3231 24.3233Z"
                                fill="#FFFFFB" />
                            <path
                                d="M21.8775 20.773L17.1046 16L21.8775 11.2271C22.1826 10.922 22.1826 10.4273 21.8775 10.1223C21.5724 9.81718 21.0777 9.81718 20.7726 10.1223L15.9997 14.8952L11.2267 10.1222C10.9217 9.81713 10.427 9.81713 10.1219 10.1222C9.81679 10.4273 9.81679 10.922 10.1219 11.2271L14.8949 16L10.1219 20.773C9.81679 21.0781 9.81679 21.5728 10.1219 21.8779C10.2744 22.0304 10.4744 22.1067 10.6743 22.1067C10.8742 22.1067 11.0742 22.0304 11.2267 21.8779L15.9997 17.1049L20.7727 21.8779C20.9252 22.0304 21.1252 22.1067 21.3251 22.1067C21.5251 22.1067 21.725 22.0304 21.8775 21.8779C22.1826 21.5728 22.1826 21.0781 21.8775 20.773Z"
                                fill="#FFFFFB" />
                        </svg>
                    </span>
                </div> */}
                <span data-bs-dismiss="modal" aria-label="Close" className="tba-modal-close-btn"></span>
                <div className="modal-body">
                    <div className="tba-modal-content">
                        <div className="tba-modal-heading">
                            <h2 className="tba-modal-title">Create New Password</h2>
                            {/* <p className="tba-modal-description">Lorem Ipsum is simply text of the typesetting industry.
                            </p> */}
                        </div>
                        <form
                  onSubmit={(e) => handleNewPassword(e)}
                  className="profileForm"
                >
                        <div className="tba-login-content">
                            <div className="tba-login-form">
                                <div className="row">
                                    <div className="col col-12 col-md-12">
                                        <label for="inputEmail" className="form-label">Password <span style={{color:"red"}}>*</span></label>
                                        <input type="password" name="password" className="form-control" placeholder="Enter password" onChange={handleInput} value={newPass.password} />
                                        <div className="text-danger">{errors.password_err}</div>
                                    </div>
                                    <div className="col col-12 col-md-12">
                                        <label for="inputEmail" className="form-label">Confirm Password <span style={{color:"red"}}>*</span></label>
                                        <input type="password" name="cpassword" className="form-control"
                                            placeholder="Enter Confirm password" onChange={handleInput} value={newPass.cpassword} />
                                            <div className="text-danger">{errors.cpassword_err}</div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary" style={{ fontSize: "15px", backgroundColor: '#f0c454' }} disabled={disable}>{disable ? 'Processing...' : 'Reset password'}</button>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
        </>
    )
}

export default NewPassword
